const PayoutIcon = () => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2_81)">
                <path d="M8.49996 1.41666C9.43016 1.41666 10.3512 1.59987 11.2106 1.95584C12.07 2.31181 12.8509 2.83357 13.5086 3.49132C14.1664 4.14907 14.6881 4.92993 15.0441 5.78932C15.4001 6.64871 15.5833 7.5698 15.5833 8.49999M8.49996 1.41666V8.49999M8.49996 1.41666C4.58794 1.41666 1.41663 4.58797 1.41663 8.49999C1.41663 12.412 4.58794 15.5833 8.49996 15.5833C12.412 15.5833 15.5833 12.412 15.5833 8.49999M8.49996 1.41666C12.412 1.41666 15.5833 4.58798 15.5833 8.49999M15.5833 8.49999L8.49996 8.49999M15.5833 8.49999C15.5833 9.61782 15.3187 10.7198 14.8113 11.7158C14.3038 12.7117 13.5678 13.5735 12.6634 14.2305L8.49996 8.49999" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2_81">
                    <rect width="17" height="17" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default PayoutIcon
